import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import moment from "moment";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const AddInvoice = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const selectInputRef = useRef();
  const [invoiceDate, setInvoiceDate] = useState();
  const [partyData, setPartyData] = useState([]);
  const [products, setProducts] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [productData, setProductData] = useState({
    name: "",
    product_id: "",
    sub_product_id: "",
    qty: "",
  });
  const [seller, setSeller] = useState({
    address: "",
    city_id: "",
    city_name: "",
    country_name: "",
    country_id: "",
    gst_no: "",
    state_id: "",
    state_name: "",
    pincode: "",
    name: "",
  });
  const [formData, setFormData] = useState({
    user_id: "",
    destination_place: "",
    remark: "",
    date: "",
    total_qty: 0,
    items: [],
    status: "",
  });
  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  const getParty = () => {
    axios.post(API_URL.PARTY_LIST, {}).then((res) => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        let pt = res.data.data.map((raw) => {
          return {
            address: raw.address ? raw.address : "",
            pincode: raw.pincode ? raw.pincode : "",
            country_name: raw.country_name ? raw.country_name : "",
            city_name: raw.city_name ? raw.city_name : "",
            gst_no: raw.gst_no ? raw.gst_no : "",
            state_name: raw.state_name ? raw.state_name : "",
            country_id: raw.country_id,
            state_id: raw.state_id,
            city_id: raw.city_id,
            name: raw.name,
            label: raw.name,
            value: raw.id,
          };
        });
        setPartyData(pt);
      }
    });
  };

  const getEdit = () => {
    axios.post(API_URL.INVOICE_GET, { id: id }).then((res) => {
      if (res.data.status == 1) {
        setFormData({
          status: res.data.data.status,
          user_id: res.data.data.user_id ? res.data.data.user_id : "",
          destination_place: res.data.data.destination_place
            ? res.data.data.destination_place
            : "",
          date: res.data.data.date ? res.data.data.date : "",
          remark: res.data.data.remark ? res.data.data.remark : "",
          total_qty: res.data.data.total_qty ? res.data.data.total_qty : "",
          items: [],
        });
        if (res.data.data.date) {
          setInvoiceDate(new Date(res.data.data.date));
        }
        let rows = res.data.data.items.map((row) => {
          let name = row.product.name;
          if (row.subproduct) {
            name = name + " - " + row.subproduct.name;
          }
          return {
            name: name,
            qty: row.qty,
            product_id: row.product_id,
            sub_product_id: row.sub_product_id,
          };
        });
        setItems(rows);
        if (res.data.data.user) {
          setSeller({
            address: res.data.data.user.address,
            city_id: res.data.data.user.city_id,
            city_name: res.data.data.user.city_name,
            state_id: res.data.data.user.state_id,
            state_name: res.data.data.user.state_name,
            country_name: res.data.data.user.country_name,
            country_id: res.data.data.user.country_id,
            pincode: res.data.data.user.pincode,
            gst_no: res.data.data.user.gst_no,
            name: res.data.data.user.name,
          });
        } else {
          setSeller({
            address: "",
            city_id: "",
            city_name: "",
            state_id: "",
            state_name: "",
            country_name: "",
            country_id: "",
            pincode: "",
            gst_no: "",
            pan_no: "",
            name: "",
          });
        }
      } else {
        toast.error(res.data.data, { autoClose: 3000, position: "top-right" });
      }
      setLoading(false);
    });
  };

  const getProducts = () => {
    axios.post(API_URL.PRODUCT_WITH_SUB_LIST, {}).then((res) => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        res.data.data.map((raw) => {
          raw.label = raw.name;
          raw.value = raw.id;
        });
        setProducts(res.data.data);
      }
      if (!id) {
        setLoading(false);
      }
    });
  };

  const setSelectedParty = (user_id) => {
    const party = partyData.find((r) => r.value == user_id);
    if (party) {
      setSeller(party);
      setFormData({
        ...formData,
        user_id: user_id,
      });
    }
  };

  const setProductValue = (e) => {
    if (e) {
      setProductData({
        ...productData,
        name: e ? e.label : "",
        product_id: e ? e.product_id : null,
        sub_product_id: e ? e.sub_product_id : null,
      });
    }
  };

  const addRow = () => {
    if (productData.product_id && productData.qty) {
      let cloneItems = [...items];
      cloneItems.push(productData);
      setItems(cloneItems);
      setProductData({
        name: "",
        product_id: "",
        sub_product_id: "",
        qty: "",
      });
      selectInputRef.current.clearValue();
    }
  };

  const deleteRow = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Product - " + items[index].name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const copyData = [...items];
        const newData = copyData.filter((_, key) => key !== index);
        setItems(newData);
        toast.success(items[index].name + " deleted successfully", {
          autoClose: 3000,
          position: "top-right",
        });
      }
    });
  };

  const calculations = () => {
    let total_qty = 0;
    items.forEach((row) => {
      total_qty += parseFloat(row.qty);
    });
    setFormData({
      ...formData,
      total_qty: total_qty,
    });
  };

  const approvOrder = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to approve this Order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios
          .post(API_URL.INVOICE_STATUS_UPDATE, {
            id: id,
            status: "Completed",
          })
          .then((res) => {
            if (res.data.status === 1) {
              toast.success("Order approved successfully", {
                autoClose: 3000,
                position: "top-right",
              });
              getParty();
              navigate(`/admin/invoice`);
            } else {
              toast.error("Failed to approve Order", {
                autoClose: 3000,
                position: "top-right",
              });
            }
            setLoading(false);
          });
      }
    });
  };

  const cancelOrder = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to cancel this Order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Cancel it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios
          .post(API_URL.INVOICE_STATUS_UPDATE, {
            id: id,
            status: "Cancelled",
          })
          .then((res) => {
            if (res.data.status === 1) {
              toast.success("Order Cancelled successfully", {
                autoClose: 3000,
                position: "top-right",
              });
              getParty();
              navigate(`/admin/invoice`);
            } else {
              toast.error("Failed to cancel Order", {
                autoClose: 3000,
                position: "top-right",
              });
            }
            setLoading(false);
          });
      }
    });
  };

  const onSave = () => {
    let payload = { ...formData };
    payload.items = [...items];
    payload.date = moment(invoiceDate).format("YYYY-MM-DD");
    const pUrl = id ? API_URL.INVOICE_UPDATE : API_URL.INVOICE_SAVE;
    if (id) {
      payload.id = id;
    }
    setLoading(true);
    axios.post(pUrl, payload).then((res) => {
      if (res.data.status === 1) {
        if (id) {
          toast.success("Updated", {
            autoClose: 3000,
            position: "top-right",
          });
        } else {
          toast.success("Saved", { autoClose: 3000, position: "top-right" });
        }
        setTimeout(() => {
          navigate("/admin/invoice/view/" + res.data.data.id, {
            replace: true,
          });
        }, 100);
      } else {
        toast.error(res.data.data, {
          autoClose: 3000,
          position: "top-right",
        });
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    calculations();
  }, [items]);

  useEffect(() => {
    getParty();
    getProducts();
  }, []);

  useEffect(() => {
    if (id) {
      getEdit();
    }
  }, [id]);
  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Update" : "Add"} Sales</h5>
          <div className="d-flex list-btn">
            <ul className="filter-list">
              {id && formData.status !== "Completed" && (
                <>
                <li>
                  <button
                    onClick={approvOrder}
                    className="btn btn-sm btn-success me-2"
                  >
                    Approve Order
                  </button>
                </li>           
                <li>
                  <button
                    onClick={cancelOrder}
                    className="btn btn-sm btn-danger me-2"
                  >
                    Cancel Order
                  </button>
                </li>
                </> 
              )}
            </ul>
          </div>
        </div>
      </div>
      {loading && <Loader></Loader>}
      {!loading && (
        <>
          <form onSubmit={(event) => event.preventDefault()}>
            <div className="row">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body">
                    <h4 className="mb-3 title-header">Party Details</h4>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="name">Party</label>
                          <Select
                            options={partyData}
                            value={partyData.find(
                              (r) => r.value == formData.user_id
                            )}
                            styles={styles}
                            onChange={(e) => {
                              setSelectedParty(e.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="address">Address</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled
                            value={seller.address}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="state">Country</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled
                            value={
                              seller.country_name ? seller.country_name : ""
                            }
                          />
                        </div>
                      </div>{" "}
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="state">State</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled
                            value={seller.state_name ? seller.state_name : ""}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="city">City</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled
                            value={seller.city_name ? seller.city_name : ""}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="state">Pincode</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled
                            value={seller.pincode ? seller.pincode : ""}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="gst_no">GST No</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled
                            value={seller.gst_no ? seller.gst_no : ""}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body">
                    <h4 className="mb-3 title-header">Product Details</h4>
                    <div className="d-flex justify-content-center align-items-center gap-3">
                      <div className="col-md-7">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Product</label>
                          <Select
                            ref={selectInputRef}
                            options={products}
                            styles={styles}
                            onChange={(e) => {
                              setProductValue(e);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Qty</label>
                          <input
                            type="number"
                            onChange={(e) => {
                              setProductData({
                                ...productData,
                                qty: e.target.value,
                                amount:
                                  e.target.value * productData.rate
                                    ? e.target.value * productData.rate
                                    : 0,
                              });
                            }}
                            value={productData.qty}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div className="form-group">
                          <label>&nbsp;</label>
                          <div>
                            <button
                              onClick={() => addRow()}
                              className="btn btn-sm btn-primary btn-outline"
                            >
                              <span className="fa fa-plus f-20 p-1"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {items.length > 0 && (
                      <table className="table table-hover">
                        <thead className="thead">
                          <tr>
                            <th style={{width: '5%'}}>#</th>
                            <th style={{ width: "75%" }}>Product</th>
                            <th style={{width: '15%'}}>Qty</th>
                            <th style={{width: '5%'}}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((e, k) => {
                            return (
                              <tr key={k}>
                                <td>{k + 1}</td>
                                <td style={{ width: "45%" }}>{e.name}</td>
                                <td>{e.qty}</td>
                                <td
                                  style={{
                                    cursor: "pointer",
                                    textAlign: "right",
                                  }}
                                >
                                  <span
                                    style={{ fontSize: "20px", color: "red" }}
                                    className="fa fa-close"
                                    onClick={() => deleteRow(k)} 
                                  ></span>
                                </td>
                              </tr>
                            );
                          })}

                          <tr
                            className="border-top"
                            style={{ backgroundColor: "whitesmoke" }}
                          >
                            <td></td>
                            <td style={{ textAlign: "right", fontWeight: "500" }}>Total Qty :</td>
                            <td style={{ fontWeight: "500", color: "#00a1b1" }}>{formData.total_qty}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="card">
              <div className="card-body">
                <h4 className="mb-3 title-header">Remark</h4>
                <textarea
                  type={"text"}
                  maxLength={255}
                  value={formData.remark}
                  placeholder="Remark"
                  className="form-control"
                  onChange={(e) =>
                    setFormData({ ...formData, remark: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
            <div className="text-end">
              <Link
                to={"/admin/invoice"}
                className={
                  loading
                    ? "btn btn-danger btn-sm me-2 disabled-link"
                    : "btn btn-danger btn-sm me-2"
                }
                onClick={(e) => loading && e.preventDefault()}
              >
                Cancel
              </Link>
              <button
                type="button"
                onClick={onSave}
                disabled={loading}
                className="btn btn-primary btn-sm"
              >
                <div className="d-flex justify-content-center align-items-center gap-2">
                  {loading && <Watch color={"white"} height={15} width={15} />}
                  Submit
                </div>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AddInvoice;
